import { z } from 'zod';

export const userRoleSchema = z.enum(['ADMIN', 'MANAGER', 'OPERATOR']);
export type UserRole = z.infer<typeof userRoleSchema>;

export const loginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
  mfaCode: z
    .string()
    .regex(/^\d{6}$/, 'TOTP code must be 6 digits')
    .optional(),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const loginSuccessResponseSchema = z.object({
  status: z.literal('ok'),
  accessToken: z.string(),
  user: z.object({
    id: z.string(),
    email: z.string().email(),
    role: userRoleSchema,
    mfaEnabled: z.boolean(),
  }),
});

export const loginMfaRequiredResponseSchema = z.object({
  status: z.literal('mfa_required'),
});

export const loginResponseSchema = z.discriminatedUnion('status', [
  loginSuccessResponseSchema,
  loginMfaRequiredResponseSchema,
]);
export type LoginResponse = z.infer<typeof loginResponseSchema>;

export const meResponseSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  role: userRoleSchema,
  mfaEnabled: z.boolean(),
});
export type MeResponse = z.infer<typeof meResponseSchema>;

export const refreshResponseSchema = z.object({
  accessToken: z.string(),
});
export type RefreshResponse = z.infer<typeof refreshResponseSchema>;

export const mfaEnableResponseSchema = z.object({
  secret: z.string(),
  qrCodeDataUrl: z.string(),
  otpauthUrl: z.string(),
});
export type MfaEnableResponse = z.infer<typeof mfaEnableResponseSchema>;

export const mfaVerifyRequestSchema = z.object({
  code: z.string().regex(/^\d{6}$/),
});
export type MfaVerifyRequest = z.infer<typeof mfaVerifyRequestSchema>;

export const mfaVerifySuccessResponseSchema = z.object({
  status: z.literal('ok'),
  recoveryCodes: z.array(z.string()),
});
export type MfaVerifySuccessResponse = z.infer<typeof mfaVerifySuccessResponseSchema>;

export const mfaDisableRequestSchema = z.object({
  password: z.string().min(1, 'Password richiesta per disabilitare MFA'),
});
export type MfaDisableRequest = z.infer<typeof mfaDisableRequestSchema>;
